import { ApplicationView, useController } from "@mixitone/mvc";
import type { PropsWithChildren } from "react";
import DeleteModal from "./DeleteModal";
import { FormController } from "./FormController";

interface FormProps {
  name: string;
  archive?: boolean;
}

const Form: React.FC<FormProps & PropsWithChildren> = ({ name, children, archive }) => {
  const controller = useController(FormController);

  const handleOnSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    controller.actionSubmit();
  };

  return (
    <>
      <form onSubmit={handleOnSubmit}>{children}</form>
      <DeleteModal name={name} archive={archive} />
    </>
  );
};

export default ApplicationView(Form);
